import { setHiddenAttachmentDocumentTypeApi } from "@/api/services/global/master";
import { TGetAttachmentDocumentTypeListOutputDto } from "@/api/services/global/master/dtos/attachment-document-type/get-master-attachment-document-type-list.dto";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenAttachmentDocumentTypeModalProps = {
  hiddenAttachmentDocumentType?: TGetAttachmentDocumentTypeListOutputDto;
  setHiddenAttachmentDocumentType: Dispatch<SetStateAction<TGetAttachmentDocumentTypeListOutputDto | undefined>>;
};

export const HiddenAttachmentDocumentTypeModal: FC<THiddenAttachmentDocumentTypeModalProps> = ({
  hiddenAttachmentDocumentType,
  setHiddenAttachmentDocumentType,
}) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenAttachmentDocumentType) return;
    try {
      await setHiddenAttachmentDocumentTypeApi(toNumber(hiddenAttachmentDocumentType.id), { isHidden: !hiddenAttachmentDocumentType.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_ATTACHMENT_DOCUMENT_TYPE] });
    } catch (error) {
      showError(error);
    } finally {
      setHiddenAttachmentDocumentType(undefined);
    }
  };

  return (
    <Modal
      title={hiddenAttachmentDocumentType?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={!!hiddenAttachmentDocumentType}
      onClose={() => setHiddenAttachmentDocumentType(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenAttachmentDocumentType?.isHidden
          ? `「${hiddenAttachmentDocumentType?.documentTypeName}」を有効にしてもよろしいですか？`
          : `「${hiddenAttachmentDocumentType?.documentTypeName}」を無効にしてもよろしいですか？`}
      </Typography>
    </Modal>
  );
};
